import { render, staticRenderFns } from "./personnelDivision.vue?vue&type=template&id=5b5102d2&scoped=true"
import script from "./personnelDivision.vue?vue&type=script&lang=js"
export * from "./personnelDivision.vue?vue&type=script&lang=js"
import style0 from "./personnelDivision.vue?vue&type=style&index=0&id=5b5102d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5102d2",
  null
  
)

export default component.exports